import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/deals/DealsClient.tsx");
